// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Select from "react-select";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";


// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;





// const RegisterUser = () => {
//   const { state } = useLocation(); // Getting userDetails from the state
//   const [formData, setFormData] = useState({
//     name: "",
//     mobile: "",
//     gender: "",
//     type: "",
//     category: [],
//     isEducation: "0", // Default to 0 (No selection)
//     education: "",
//     experience: "",
//     email: "",
//     doorNumber: "",
//     street: "",
//     place: "",
//     district: "",
//     city: "",
//     pincode: "",
//     otherDetails: "",
//     webLinks: "",
//     youtubeLinks: "",
//     facebookLinks: "",
//     dnd: "",
//     image1: "",
//     image2: "",
//     idProof: "",
//     addressProof: "",
//     otherProof: "",
//   });

//   const [categories, setCategories] = useState([]);
//   const [districts, setDistricts] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [loading, setLoading] = useState({ categories: false, cities: false });


//   const navigate = useNavigate(); // Initialize navigate


//   // Fetch categories based on selected type
//   // useEffect(() => {
//   //   const fetchCategoriesByType = async () => {
//   //     if (!formData.type) {
//   //       setCategories([]);
//   //       return;
//   //     }
//   //     setLoading((prev) => ({ ...prev, categories: true }));
//   //     try {
//   //       const response = await fetch(`${API_BASE_URL}/categories?type=${formData.type}`);
//   //       if (response.ok) {
//   //         const data = await response.json();
//   //         setCategories(
//   //           data.map((item) => ({
//   //             value: item.id,
//   //             label: item.category,
//   //           }))
//   //         );
//   //       } else {
//   //         console.error("Failed to fetch categories");
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching categories:", err);
//   //     } finally {
//   //       setLoading((prev) => ({ ...prev, categories: false }));
//   //     }
//   //   };
//   //   fetchCategoriesByType();
//   // }, [formData.type]);
//   useEffect(() => {
//     const fetchCategoriesByType = async () => {
//         if (!formData.type) {
//             setCategories([]);
//             return;
//         }
//         setLoading((prev) => ({ ...prev, categories: true }));
//         try {
//             const response = await fetch(`${API_BASE_URL}/categories?type=${formData.type}`);
//             if (response.ok) {
//                 const data = await response.json();
//                 console.log("Categories Fetched:", data); // Debugging
//                 setCategories(
//                     data.map((item) => ({
//                         value: item.id,
//                         label: item.category,
//                     }))
//                 );
//             } else {
//                 console.error("Failed to fetch categories");
//             }
//         } catch (err) {
//             console.error("Error fetching categories:", err);
//         } finally {
//             setLoading((prev) => ({ ...prev, categories: false }));
//         }
//     };
//     fetchCategoriesByType();
// }, [formData.type]);


//   // Fetch districts
//   useEffect(() => {
//     const fetchDistricts = async () => {
//       try {
//         const response = await fetch(`${API_BASE_URL}/districts`);
//         if (response.ok) {
//           const data = await response.json();
//           setDistricts(data);
//         } else {
//           console.error("Failed to fetch districts");
//         }
//       } catch (err) {
//         console.error("Error fetching districts:", err);
//       }
//     };
//     fetchDistricts();
//   }, []);

//   // Populate form fields if `userDetails` exists in state
//   useEffect(() => {
//     if (state?.userDetails) {
//         const userDetails = state.userDetails;
        
//         // Fetch cities first based on the district
//         const fetchCitiesForDistrict = async () => {
//             try {
//                 const response = await fetch(`${API_BASE_URL}/cities?districtId=${userDetails.district}`);
//                 if (response.ok) {
//                     const data = await response.json();
//                     setCities(data);

//                     // Ensure the city ID matches an available city
//                     const matchedCity = data.find(city => city.id == userDetails.city); // Ensure type consistency
//                     setFormData(prevFormData => ({
//                         ...prevFormData,
//                         name: userDetails.name || "",
//                         mobile: userDetails.mobileNo || "",
//                         gender: userDetails.gender || "",
//                         type: userDetails.type || "",
//                         category: userDetails.category || [],
//                         isEducation: userDetails.isEducation?.toString() || "0",
//                         education: userDetails.isEducation === 1 ? userDetails.education || "" : "",
//                         experience: userDetails.experience || "",
//                         email: userDetails.email || "",
//                         doorNumber: userDetails.doorNumber || "",
//                         street: userDetails.street || "",
//                         place: userDetails.place || "",
//                         district: userDetails.district || "",
//                         city: matchedCity ? matchedCity.id : "", // Ensure correct mapping
//                         pincode: userDetails.pincode || "",
//                         otherDetails: userDetails.other_details || "",
//                         webLinks: userDetails.webLink || "",
//                         youtubeLinks: userDetails.youtubeLink || "",
//                         facebookLinks: userDetails.facebookLink || "",
//                         image1: userDetails.image1 || "",
//                         image2: userDetails.image2 || "",
//                         idProof: userDetails.idproof || "",
//                         addressProof: userDetails.addressproof || "",
//                         otherProof: userDetails.otherproof || "",
//                     }));
//                 } else {
//                     console.error("Failed to fetch cities");
//                 }
//             } catch (err) {
//                 console.error("Error fetching cities:", err);
//             }
//         };

//         fetchCitiesForDistrict();
//     }
// }, [state]);




// const handleDistrictChange = async (e) => {
//   const districtId = e.target.value;
//   setFormData({ ...formData, district: districtId, city: "" });
//   setLoading((prev) => ({ ...prev, cities: true }));

//   try {
//       const response = await fetch(`${API_BASE_URL}/cities?districtId=${districtId}`);
//       if (response.ok) {
//           const data = await response.json();
//           setCities(data);

//           // Automatically set city if it exists in the new list
//           if (formData.city) {
//               const matchedCity = data.find((city) => city.id === formData.city);
//               if (matchedCity) {
//                   setFormData((prev) => ({ ...prev, city: matchedCity.id }));
//               }
//           }
//       } else {
//           console.error("Failed to fetch cities");
//       }
//   } catch (err) {
//       console.error("Error fetching cities:", err);
//   } finally {
//       setLoading((prev) => ({ ...prev, cities: false }));
//   }
// };


//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // Handle category selection
//   const handleCategoryChange = (selectedOptions) => {
//     setFormData({
//       ...formData,
//       category: selectedOptions.map((option) => option.value),
//     });
//   };

//   // Handle file uploads
//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     setFormData({ ...formData, [name]: files[0] });
//   };

//   // Submit form data
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   const formDataToSend = new FormData();
//   //   Object.keys(formData).forEach((key) => {
//   //     if (key === "category") {
//   //       formDataToSend.append(key, formData[key].join(","));
//   //     } else if (formData[key] instanceof File) {
//   //       formDataToSend.append(key, formData[key]);
//   //     } else {
//   //       formDataToSend.append(key, formData[key]);
//   //     }
//   //   });

//   //   try {
//   //     const response = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//   //       headers: { "Content-Type": "multipart/form-data" },
//   //     });

//   //     if (response.status === 200) {
//   //       alert("User updated successfully!");
//   //       navigate("/transactions/Registeredusers"); // Redirect after success
//   //     }
//   //   } catch (err) {
//   //     console.error("Error submitting form:", err);
//   //     alert("An error occurred. Please try again.");
//   //   }
//   // };
  
// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     const formDataToSend = new FormData();
    
// //     Object.keys(formData).forEach((key) => {
// //         if (key === "category") {
// //             // Ensure category is always treated as an array
// //             const categoryArray = Array.isArray(formData[key]) ? formData[key] : [formData[key]];
// //             formDataToSend.append(key, categoryArray.join(","));
// //         } else if (formData[key] instanceof File) {
// //             formDataToSend.append(key, formData[key]);
// //         } else {
// //             formDataToSend.append(key, formData[key]);
// //         }
// //     });

// //     try {
// //         const response = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
// //             headers: { "Content-Type": "multipart/form-data" },
// //         });

// //         if (response.status === 200) {
// //             alert("User updated successfully!");
// //             navigate("/transactions/Registeredusers"); // Redirect after success
// //         }
// //     } catch (err) {
// //         console.error("Error submitting form:", err);
// //         alert("An error occurred. Please try again.");
// //     }
// // };



// // const handleSubmit = async (e) => {
// //   e.preventDefault();
// //   const formDataToSend = new FormData();

// //   // Convert form data into FormData object
// //   Object.keys(formData).forEach((key) => {
// //       if (key === "category") {
// //           // Ensure category is always treated as an array
// //           const categoryArray = Array.isArray(formData[key]) ? formData[key] : [formData[key]];
// //           formDataToSend.append(key, categoryArray.join(","));
// //       } else if (formData[key] instanceof File) {
// //           formDataToSend.append(key, formData[key]);
// //       } else {
// //           formDataToSend.append(key, formData[key]);
// //       }
// //   });

// //   try {
// //       let uploadedImage1 = formData.image1;
// //       let uploadedImage2 = formData.image2;

// //       // Upload images to external API if they exist
// //       if (formData.image1 || formData.image2) {
// //           const uploadData = new FormData();
// //           uploadData.append("action", "img_upload");
// //           if (formData.image1) uploadData.append("image", formData.image1);
// //           if (formData.image2) uploadData.append("other_image", formData.image2);

// //           const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
// //               headers: { "Content-Type": "multipart/form-data" },
// //           });

// //           if (uploadResponse.status === 200 && uploadResponse.data) {
// //               uploadedImage1 = uploadResponse.data.image_url || uploadedImage1;
// //               uploadedImage2 = uploadResponse.data.other_image_url || uploadedImage2;
// //           }
// //       }

// //       // Update form data with uploaded image URLs
// //       formDataToSend.set("image1", uploadedImage1);
// //       formDataToSend.set("image2", uploadedImage2);

// //       // Send updated form data to your API
// //       const response = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
// //           headers: { "Content-Type": "multipart/form-data" },
// //       });

// //       if (response.status === 200) {
// //           alert("User updated successfully!");
// //           navigate("/transactions/Registeredusers"); // Redirect after success
// //       }
// //   } catch (err) {
// //       console.error("Error submitting form:", err);
// //       alert("An error occurred. Please try again.");
// //   }
// // };

// const handleSubmit = async (e) => {
//   e.preventDefault();

//   // Ensure we have a valid user_id before proceeding.
//   // If formData.user_id is not already set, try searching for the user.
//   if (!formData.user_id) {
//     try {
//       const searchResponse = await fetch(
//         `${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`
//       );
//       const searchData = await searchResponse.json();
//       if (searchResponse.ok && searchData.id) {
//         formData.user_id = searchData.id;
//       } else {
//         alert("User not found. Cannot update a non-existent user.");
//         return;
//       }
//     } catch (err) {
//       console.error("Error searching for user:", err);
//       alert("An error occurred while searching for the user.");
//       return;
//     }
//   }

//   // Create a FormData object with the current form values.
//   const formDataToSend = new FormData();
//   Object.keys(formData).forEach((key) => {
//     if (key === "category") {
//       // Ensure category is always treated as an array
//       const categoryArray = Array.isArray(formData[key])
//         ? formData[key]
//         : [formData[key]];
//       formDataToSend.append(key, categoryArray.join(","));
//     } else if (formData[key] instanceof File) {
//       formDataToSend.append(key, formData[key]);
//     } else {
//       formDataToSend.append(key, formData[key]);
//     }
//   });

//   try {
//     // Set initial image values (in case no new image is provided)
//     let uploadedImage1 = formData.image1;
//     let uploadedImage2 = formData.image2;

//     // Upload images to external API if they exist.
//     // Note: Now we include the user_id in the upload request.
//     if (formData.image1 || formData.image2) {
//       const uploadData = new FormData();
//       uploadData.append("action", "img_upload");
//       uploadData.append("user_id", formData.user_id || "");
//       if (formData.image1) uploadData.append("image", formData.image1);
//       if (formData.image2) uploadData.append("other_image", formData.image2);

//       const uploadResponse = await axios.post(
//         "https://nithra.mobi/calendar/services/api/img_upload.php",
//         uploadData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       if (uploadResponse.status === 200 && uploadResponse.data) {
//         uploadedImage1 = uploadResponse.data.image_url || uploadedImage1;
//         uploadedImage2 = uploadResponse.data.other_image_url || uploadedImage2;
//       }
//     }

//     // Update formDataToSend with the uploaded image URLs.
//     formDataToSend.set("image1", uploadedImage1);
//     formDataToSend.set("image2", uploadedImage2);

//     // Finally, send the updated form data to your API for updating the user.
//     const response = await axios.put(
//       `${API_BASE_URL}/update_user_new`,
//       formDataToSend,
//       { headers: { "Content-Type": "multipart/form-data" } }
//     );

//     if (response.status === 200) {
//       alert("User updated successfully!");
//       navigate("/transactions/Registeredusers"); // Redirect after success
//     }
//   } catch (err) {
//     console.error("Error submitting form:", err);
//     alert("An error occurred. Please try again.");
//   }
// };




  
//   return (


//     <div className="max-w-5xl mx-auto p-3">
//           <div className="max-w-6xl mx-auto mt-9 px-4 py-1 bg-blue-900  shadow-md rounded mb-7">

//     <h1 className="text-2xl font-bold text-white mb-5">User Updation</h1>
    
//     {/* Additional Section Above the Form */}
//     <div className="mb-6">
    
//     </div>
//     </div>
//     <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {/* Name */}
//                 <div>
//                   <label htmlFor="name" className="block text-sm">
//                     Name<span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter your name"
//                     required
//                   />
//                 </div>
      
//                 {/* Mobile No */}
//                 <div>
//                   <label htmlFor="mobile" className="block text-sm">
//                     Mobile No<span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="mobile"
//                     name="mobile"
//                     value={formData.mobile}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter mobile number"
//                     required
//                   />
//                 </div>
      
//                 {/* Gender */}
//                 <div>
//                   <label htmlFor="gender" className="block text-sm">
//                     Gender<span className="text-red-500">*</span>
//                   </label>
//                   <div className="flex gap-4 mt-2">
//                     <label className="flex items-center">
//                       <input
//                         type="radio"
//                         name="gender"
//                         value="ஆண்"
//                         checked={formData.gender === "ஆண்"}
//                         onChange={handleChange}
//                         required
//                       />
//                       <span className="ml-2">ஆண்</span>
//                     </label>
//                     <label className="flex items-center">
//                       <input
//                         type="radio"
//                         name="gender"
//                         value="பெண்"
//                         checked={formData.gender === "பெண்"}
//                         onChange={handleChange}
//                         required
//                       />
//                       <span className="ml-2">பெண்</span>
//                     </label>
//                   </div>
//                 </div>
      
//                 {/* Type */}
//                 <div>
//                   <label htmlFor="type" className="block text-sm">
//                     Type<span className="text-red-500">*</span>
//                   </label>
//                   <select
//                     name="type"
//                     value={formData.type}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     required
//                   >
//                     <option value="">Select Type</option>
//                     <option value="ஜோதிடர்">ஜோதிடர்</option>
//                     <option value="ஐயர்">ஐயர்</option>
//                     <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
//                     <option value="எண்கணிதம்">எண்கணிதம்</option>
//                     <option value="சிற்பி">சிற்பி</option>
//                     <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
//                     <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
//                     <option value="திருவிழா அலங்காரம் செய்பவர்">
//                       திருவிழா அலங்காரம் செய்பவர்
//                     </option>
//                     <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
//                     <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
//                   </select>
//                 </div>
      
//                 {/* Category */}
//                 <div>
//                   <label htmlFor="category" className="block text-sm">
//                     Category<span className="text-red-500"></span>
//                   </label>
//                   <Select
//                     isMulti
//                     options={categories}
//                     value={categories.filter((cat) =>
//                       formData.category.includes(cat.value)
//                     )}
//                     onChange={handleCategoryChange}
//                     className="w-full"
//                     placeholder="Select categories"
//                     isLoading={loading.categories}
                    
//                   />
//                 </div>
      
//                 <div>
//     <label className="block text-sm">Is Education</label>
//     <div className="flex gap-4">
//         <label>
//             <input
//                 type="radio"
//                 name="isEducation"
//                 value="1"
//                 onChange={handleChange}
//                 checked={formData.isEducation === "1"}
//             />
//             Yes
//         </label>
//         <label>
//             <input
//                 type="radio"
//                 name="isEducation"
//                 value="2"
//                 onChange={handleChange}
//                 checked={formData.isEducation === "2"}
//             />
//             No
//         </label>
//         <label>
//             {/* <input
//                 type="radio"
//                 name="isEducation"
//                 value="0"
//                 onChange={handleChange}
//                 checked={formData.isEducation === "0"}
//             /> */}
            
//         </label>
//     </div>
// </div>


// {/* Show Education field only when isEducation is '1' */}
// {formData.isEducation === "1" && (
//     <div>
//         <label htmlFor="education" className="block text-sm">
//             Education
//         </label>
//         <input
//             type="text"
//             id="education"
//             name="education"
//             value={formData.education}
//             onChange={handleChange}
//             className="w-full p-2 border rounded"
//             placeholder="Enter Education"
//             required
//         />
//     </div>
// )}
//                 {/* Experience */}
//                 <div>
//                   <label htmlFor="experience" className="block text-sm">
//                     Experience<span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="experience"
//                     name="experience"
//                     value={formData.experience}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter experience"
//                     required
//                   />
//                 </div>
      
//                 {/* Email */}
//                 <div>
//                   <label htmlFor="email" className="block text-sm">
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter email"
//                   />
//                 </div>
      
//                 {/* Door Number */}
//                 <div>
//                   <label className="block text-sm">Door Number</label>
//                   <input
//                     type="text"
//                     name="doorNumber"
//                     value={formData.doorNumber}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* Street */}
//                 <div>
//                   <label htmlFor="street" className="block text-sm">
//                     Street
//                   </label>
//                   <input
//                     type="text"
//                     id="street"
//                     name="street"
//                     value={formData.street}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter street"
//                   />
//                 </div>
      
//                 {/* Place */}
//                 <div>
//                   <label className="block text-sm">Place</label>
//                   <input
//                     type="text"
//                     name="place"
//                     value={formData.place}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* District */}
//                 <div>
//                   <label htmlFor="district" className="block text-sm">
//                     District<span className="text-red-500">*</span>
//                   </label>
//                   <select
//                     name="district"
//                     value={formData.district}
//                     onChange={handleDistrictChange}
//                     className="w-full p-2 border rounded"
//                     required
//                   >
//                     <option value="">Select District</option>
//                     {districts.map((district) => (
//                       <option key={district.id} value={district.id}>
//                         {district.tamil}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
      
//                 {/* City */}
//           {/* City */}
// <div>
//     <label htmlFor="city" className="block text-sm">
//         City<span className="text-red-500">*</span>
//     </label>
//     <select
//     name="city"
//     value={formData.city}
//     onChange={handleChange}
//     className="w-full p-2 border rounded"
//     disabled={loading.cities}
//     required
// >
//     <option value="">Select City</option>
//     {cities.map((city) => (
//         <option key={city.id} value={city.id}>
//             {city.tamil}
//         </option>
//     ))}
// </select>

// </div>
      
//                 {/* Pincode */}
//                 <div>
//                   <label className="block text-sm">Pincode<span className="text-red-500">*</span></label>
//                   <input
//                     type="text"
//                     name="pincode"
//                     value={formData.pincode}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                     required
//                   />
//                 </div>
      
//                 {/* Other Details */}
//                 <div>
//                   <label className="block text-sm">Other Details</label>
//                   <textarea
//                     name="otherDetails"
//                     value={formData.otherDetails}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   ></textarea>
//                 </div>
      
//                 {/* Web Links */}
//                 <div>
//                   <label className="block text-sm">Web Links</label>
//                   <input
//                     type="text"
//                     name="webLinks"
//                     value={formData.webLinks}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* YouTube Links */}
//                 <div>
//                   <label className="block text-sm">YouTube Links</label>
//                   <input
//                     type="text"
//                     name="youtubeLinks"
//                     value={formData.youtubeLinks}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* Facebook Links */}
//                 <div>
//                   <label className="block text-sm">Facebook Links</label>
//                   <input
//                     type="text"
//                     name="facebookLinks"
//                     value={formData.facebookLinks}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* DND */}
//                 <div>
//                   <label className="block text-sm">DND</label>
//                   <select
//                     name="dnd"
//                     value={formData.dnd}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   >
//                     <option value="">Show all</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                 </div>
      
//                 {/* Image 1 Upload */}
//                 <div>
//                   <label className="block text-sm">Image 1 Upload</label>
//                   <input
//                     type="file"
//                     name="image1"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.image1 && (
//                   <img
//                 //   src={`http://localhost:3036/uploads/${formData.image1}`}
//                   src={formData.image1}
//                   alt="Image 1"
//                   className="w-40 h-40 object-cover"
//               />
//                   )}
//                 </div>
      
//                 {/* Image 2 Upload */}
//                 <div>
//                   <label className="block text-sm">Image 2 Upload</label>
//                   <input
//                     type="file"
//                     name="image2"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.image2 && (
//                     <img
//                     // src={`http://localhost:3036/uploads/${formData.image2}`}
//                     src={formData.image2}
//                     alt=""
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
      
//                 {/* ID Proof Upload */}
//                 <div>
//                   <label className="block text-sm">ID Proof</label>
//                   <input
//                     type="file"
//                     name="idProof"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.idProof && (
//                     <img
//                 //   src={`http://localhost:3036/uploads/${formData.idProof}`}
//                 src={formData.idProof}

//                       alt=""
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
//                 {/* Address Proof Upload */}
//                 <div>
//                   <label className="block text-sm">Address Proof</label>
//                   <input
//                     type="file"
//                     name="addressProof"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.addressProof && (
//                     <img
//                     // src={`http://localhost:3036/uploads/${formData.addressProof}`}
//                     src={formData.addressProof}

//                       alt=""
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
      
//                 {/* Other Proof Upload */}
//                 <div>
//                   <label className="block text-sm">Other Proof</label>
//                   <input
//                     type="file"
//                     name="otherProof"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.otherProof && (
//                     <img
//                     // src={`http://localhost:3036/uploads/${formData.otherProof}`}
//                     src={formData.otherProof}

//                       alt="Other Proof"
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
      
//                 {/* Submit Button */}
//                 <div className="mt-6 flex justify-end">
//                   <button
//                     type="submit"
//                     className="bg-blue-600 text-white px-4 py-2 rounded"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
      
//       {alert.message && (
//         <div
//           className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg z-50 ${
//             alert.type === "success" ? "bg-green-500" : "bg-red-500"
//           }`}
//         >
//           <span>{alert.message}</span>
//         </div>
//       )}

//     </div>
    
//   );
// };

// export default RegisterUser;











import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;





const RegisterUser = () => {
  const { state } = useLocation(); // Getting userDetails from the state
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    altermobile:"",
    gender: "",
    type: "",
    category: [],
    isEducation: "0", // Default to 0 (No selection)
    education: "",
    experience: "",
    email: "",
    doorNumber: "",
    street: "",
    place: "",
    district: "",
    city: "",
    pincode: "",
    otherDetails: "",
    webLinks: "",
    youtubeLinks: "",
    facebookLinks: "",
    dnd: "",
    image1: "",
    image2: "",
    idProof: "",
    addressProof: "",
    otherProof: "",
  });

  const [categories, setCategories] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState({ categories: false, cities: false });


  const navigate = useNavigate(); // Initialize navigate


  // Fetch categories based on selected type
  // useEffect(() => {
  //   const fetchCategoriesByType = async () => {
  //     if (!formData.type) {
  //       setCategories([]);
  //       return;
  //     }
  //     setLoading((prev) => ({ ...prev, categories: true }));
  //     try {
  //       const response = await fetch(`${API_BASE_URL}/categories?type=${formData.type}`);
  //       if (response.ok) {
  //         const data = await response.json();
  //         setCategories(
  //           data.map((item) => ({
  //             value: item.id,
  //             label: item.category,
  //           }))
  //         );
  //       } else {
  //         console.error("Failed to fetch categories");
  //       }
  //     } catch (err) {
  //       console.error("Error fetching categories:", err);
  //     } finally {
  //       setLoading((prev) => ({ ...prev, categories: false }));
  //     }
  //   };
  //   fetchCategoriesByType();
  // }, [formData.type]);
  useEffect(() => {
    const fetchCategoriesByType = async () => {
        if (!formData.type) {
            setCategories([]);
            return;
        }
        setLoading((prev) => ({ ...prev, categories: true }));
        try {
            const response = await fetch(`${API_BASE_URL}/categories?type=${formData.type}`);
            if (response.ok) {
                const data = await response.json();
                console.log("Categories Fetched:", data); // Debugging
                setCategories(
                    data.map((item) => ({
                        value: item.id,
                        label: item.category,
                    }))
                );
            } else {
                console.error("Failed to fetch categories");
            }
        } catch (err) {
            console.error("Error fetching categories:", err);
        } finally {
            setLoading((prev) => ({ ...prev, categories: false }));
        }
    };
    fetchCategoriesByType();
}, [formData.type]);


  // Fetch districts
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/districts`);
        if (response.ok) {
          const data = await response.json();
          setDistricts(data);
        } else {
          console.error("Failed to fetch districts");
        }
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };
    fetchDistricts();
  }, []);

  // Populate form fields if `userDetails` exists in state
  useEffect(() => {
    if (state?.userDetails) {
        const userDetails = state.userDetails;
        
        // Fetch cities first based on the district
        const fetchCitiesForDistrict = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/cities?districtId=${userDetails.district}`);
                if (response.ok) {
                    const data = await response.json();
                    setCities(data);

                    // Ensure the city ID matches an available city
                    const matchedCity = data.find(city => city.id == userDetails.city); // Ensure type consistency
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        name: userDetails.name || "",
                        mobile: userDetails.mobileNo || "",
                        altermobile:userDetails.altermobile||"",
                        gender: userDetails.gender || "",
                        type: userDetails.type || "",
                        category: userDetails.category || [],
                        isEducation: userDetails.isEducation?.toString() || "0",
                        education: userDetails.isEducation === 1 ? userDetails.education || "" : "",
                        experience: userDetails.experience || "",
                        email: userDetails.email || "",
                        doorNumber: userDetails.doorNumber || "",
                        street: userDetails.street || "",
                        place: userDetails.place || "",
                        district: userDetails.district || "",
                        city: matchedCity ? matchedCity.id : "", // Ensure correct mapping
                        pincode: userDetails.pincode || "",
                        otherDetails: userDetails.other_details || "",
                        webLinks: userDetails.webLink || "",
                        youtubeLinks: userDetails.youtubeLink || "",
                        facebookLinks: userDetails.facebookLink || "",
                        image1: userDetails.image1 || "",
                        image2: userDetails.image2 || "",
                        idProof: userDetails.idproof || "",
                        addressProof: userDetails.addressproof || "",
                        otherProof: userDetails.otherproof || "",
                    }));
                } else {
                    console.error("Failed to fetch cities");
                }
            } catch (err) {
                console.error("Error fetching cities:", err);
            }
        };

        fetchCitiesForDistrict();
    }
}, [state]);




const handleDistrictChange = async (e) => {
  const districtId = e.target.value;
  setFormData({ ...formData, district: districtId, city: "" });
  setLoading((prev) => ({ ...prev, cities: true }));

  try {
      const response = await fetch(`${API_BASE_URL}/cities?districtId=${districtId}`);
      if (response.ok) {
          const data = await response.json();
          setCities(data);

          // Automatically set city if it exists in the new list
          if (formData.city) {
              const matchedCity = data.find((city) => city.id === formData.city);
              if (matchedCity) {
                  setFormData((prev) => ({ ...prev, city: matchedCity.id }));
              }
          }
      } else {
          console.error("Failed to fetch cities");
      }
  } catch (err) {
      console.error("Error fetching cities:", err);
  } finally {
      setLoading((prev) => ({ ...prev, cities: false }));
  }
};


  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle category selection
  const handleCategoryChange = (selectedOptions) => {
    setFormData({
      ...formData,
      category: selectedOptions.map((option) => option.value),
    });
  };

  // Handle file uploads
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  // Submit form data
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const formDataToSend = new FormData();
  //   Object.keys(formData).forEach((key) => {
  //     if (key === "category") {
  //       formDataToSend.append(key, formData[key].join(","));
  //     } else if (formData[key] instanceof File) {
  //       formDataToSend.append(key, formData[key]);
  //     } else {
  //       formDataToSend.append(key, formData[key]);
  //     }
  //   });

  //   try {
  //     const response = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });

  //     if (response.status === 200) {
  //       alert("User updated successfully!");
  //       navigate("/transactions/Registeredusers"); // Redirect after success
  //     }
  //   } catch (err) {
  //     console.error("Error submitting form:", err);
  //     alert("An error occurred. Please try again.");
  //   }
  // };
  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const formDataToSend = new FormData();
    
//     Object.keys(formData).forEach((key) => {
//         if (key === "category") {
//             // Ensure category is always treated as an array
//             const categoryArray = Array.isArray(formData[key]) ? formData[key] : [formData[key]];
//             formDataToSend.append(key, categoryArray.join(","));
//         } else if (formData[key] instanceof File) {
//             formDataToSend.append(key, formData[key]);
//         } else {
//             formDataToSend.append(key, formData[key]);
//         }
//     });

//     try {
//         const response = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//             headers: { "Content-Type": "multipart/form-data" },
//         });

//         if (response.status === 200) {
//             alert("User updated successfully!");
//             navigate("/transactions/Registeredusers"); // Redirect after success
//         }
//     } catch (err) {
//         console.error("Error submitting form:", err);
//         alert("An error occurred. Please try again.");
//     }
// };



const handleSubmit = async (e) => {
  e.preventDefault();
  const formDataToSend = new FormData();

  // Convert form data into FormData object
  Object.keys(formData).forEach((key) => {
      if (key === "category") {
          // Ensure category is always treated as an array
          const categoryArray = Array.isArray(formData[key]) ? formData[key] : [formData[key]];
          formDataToSend.append(key, categoryArray.join(","));
      } else if (formData[key] instanceof File) {
          formDataToSend.append(key, formData[key]);
      } else {
          formDataToSend.append(key, formData[key]);
      }
  });

  try {
      let uploadedImage1 = formData.image1;
      let uploadedImage2 = formData.image2;

      // Upload images to external API if they exist
      if (formData.image1 || formData.image2) {
          const uploadData = new FormData();
          uploadData.append("action", "img_upload");
          if (formData.image1) uploadData.append("image", formData.image1);
          if (formData.image2) uploadData.append("other_image", formData.image2);

          const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
              headers: { "Content-Type": "multipart/form-data" },
          });

          if (uploadResponse.status === 200 && uploadResponse.data) {
              uploadedImage1 = uploadResponse.data.image_url || uploadedImage1;
              uploadedImage2 = uploadResponse.data.other_image_url || uploadedImage2;
          }
      }

      // Update form data with uploaded image URLs
      formDataToSend.set("image1", uploadedImage1);
      formDataToSend.set("image2", uploadedImage2);

      // Send updated form data to your API
      const response = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
          headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
          alert("User updated successfully!");
          navigate("/transactions/Registeredusers"); // Redirect after success
      }
  } catch (err) {
      console.error("Error submitting form:", err);
      alert("An error occurred. Please try again.");
  }
};



  
  return (


    <div className="max-w-5xl mx-auto p-3">
          <div className="max-w-6xl mx-auto mt-9 px-4 py-1 bg-blue-900  shadow-md rounded mb-7">

    <h1 className="text-2xl font-bold text-white mb-5">User Updation</h1>
    
    {/* Additional Section Above the Form */}
    <div className="mb-6">
    
    </div>
    </div>
    <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Name */}
                <div>
                  <label htmlFor="name" className="block text-sm">
                    Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter your name"
                    required
                  />
                </div>
      
                {/* Mobile No */}
                <div>
                  <label htmlFor="mobile" className="block text-sm">
                    Mobile No<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter mobile number"
                    required
                  />
                </div>
             
                <div>
                  <label htmlFor="mobile" className="block text-sm">
                    Alternate Mobile No
                  </label>
                  <input
                    type="text"
                    id="altermobile"
                    name="altermobile"
                    value={formData.altermobile}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter Alternate mobile number"
                    
                  />
                </div> 
      
                {/* Gender */}
                <div>
                  <label htmlFor="gender" className="block text-sm">
                    Gender<span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4 mt-2">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="ஆண்"
                        checked={formData.gender === "ஆண்"}
                        onChange={handleChange}
                        required
                      />
                      <span className="ml-2">ஆண்</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="பெண்"
                        checked={formData.gender === "பெண்"}
                        onChange={handleChange}
                        required
                      />
                      <span className="ml-2">பெண்</span>
                    </label>
                  </div>
                </div>
      
                {/* Type */}
                <div>
                  <label htmlFor="type" className="block text-sm">
                    Type<span className="text-red-500">*</span>
                  </label>
                  <select
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="ஜோதிடர்">ஜோதிடர்</option>
                    <option value="ஐயர்">ஐயர்</option>
                    <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                    <option value="எண்கணிதம்">எண்கணிதம்</option>
                    <option value="சிற்பி">சிற்பி</option>
                    <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
                    <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
                    <option value="திருவிழா அலங்காரம் செய்பவர்">
                      திருவிழா அலங்காரம் செய்பவர்
                    </option>
                    <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
                    <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
                  </select>
                </div>
      
                {/* Category */}
                <div>
                  <label htmlFor="category" className="block text-sm">
                    Category<span className="text-red-500"></span>
                  </label>
                  <Select
                    isMulti
                    options={categories}
                    value={categories.filter((cat) =>
                      formData.category.includes(cat.value)
                    )}
                    onChange={handleCategoryChange}
                    className="w-full"
                    placeholder="Select categories"
                    isLoading={loading.categories}
                    
                  />
                </div>
      
                <div>
    <label className="block text-sm">Is Education</label>
    <div className="flex gap-4">
        <label>
            <input
                type="radio"
                name="isEducation"
                value="1"
                onChange={handleChange}
                checked={formData.isEducation === "1"}
            />
            Yes
        </label>
        <label>
            <input
                type="radio"
                name="isEducation"
                value="2"
                onChange={handleChange}
                checked={formData.isEducation === "2"}
            />
            No
        </label>
        <label>
            {/* <input
                type="radio"
                name="isEducation"
                value="0"
                onChange={handleChange}
                checked={formData.isEducation === "0"}
            /> */}
            
        </label>
    </div>
</div>


{/* Show Education field only when isEducation is '1' */}
{formData.isEducation === "1" && (
    <div>
        <label htmlFor="education" className="block text-sm">
            Education
        </label>
        <input
            type="text"
            id="education"
            name="education"
            value={formData.education}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Enter Education"
            required
        />
    </div>
)}
                {/* Experience */}
                <div>
                  <label htmlFor="experience" className="block text-sm">
                    Experience<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter experience"
                    required
                  />
                </div>
      
                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-sm">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter email"
                  />
                </div>
      
                {/* Door Number */}
                <div>
                  <label className="block text-sm">Door Number</label>
                  <input
                    type="text"
                    name="doorNumber"
                    value={formData.doorNumber}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* Street */}
                <div>
                  <label htmlFor="street" className="block text-sm">
                    Street
                  </label>
                  <input
                    type="text"
                    id="street"
                    name="street"
                    value={formData.street}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter street"
                  />
                </div>
      
                {/* Place */}
                <div>
                  <label className="block text-sm">Place</label>
                  <input
                    type="text"
                    name="place"
                    value={formData.place}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* District */}
                <div>
                  <label htmlFor="district" className="block text-sm">
                    District<span className="text-red-500">*</span>
                  </label>
                  <select
                    name="district"
                    value={formData.district}
                    onChange={handleDistrictChange}
                    className="w-full p-2 border rounded"
                    required
                  >
                    <option value="">Select District</option>
                    {districts.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.tamil}
                      </option>
                    ))}
                  </select>
                </div>
      
                {/* City */}
          {/* City */}
<div>
    <label htmlFor="city" className="block text-sm">
        City<span className="text-red-500">*</span>
    </label>
    <select
    name="city"
    value={formData.city}
    onChange={handleChange}
    className="w-full p-2 border rounded"
    disabled={loading.cities}
    required
>
    <option value="">Select City</option>
    {cities.map((city) => (
        <option key={city.id} value={city.id}>
            {city.tamil}
        </option>
    ))}
</select>

</div>
      
                {/* Pincode */}
                <div>
                  <label className="block text-sm">Pincode<span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                    required
                  />
                </div>
      
                {/* Other Details */}
                <div>
                  <label className="block text-sm">Other Details</label>
                  <textarea
                    name="otherDetails"
                    value={formData.otherDetails}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  ></textarea>
                </div>
      
                {/* Web Links */}
                <div>
                  <label className="block text-sm">Web Links</label>
                  <input
                    type="text"
                    name="webLinks"
                    value={formData.webLinks}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* YouTube Links */}
                <div>
                  <label className="block text-sm">YouTube Links</label>
                  <input
                    type="text"
                    name="youtubeLinks"
                    value={formData.youtubeLinks}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* Facebook Links */}
                <div>
                  <label className="block text-sm">Facebook Links</label>
                  <input
                    type="text"
                    name="facebookLinks"
                    value={formData.facebookLinks}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* DND */}
                <div>
                  <label className="block text-sm">DND</label>
                  <select
                    name="dnd"
                    value={formData.dnd}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  >
                    <option value="">Show all</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
      
                {/* Image 1 Upload */}
                <div>
                  <label className="block text-sm">Image 1 Upload</label>
                  <input
                    type="file"
                    name="image1"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.image1 && (
                                                    <img src={`${API_BASE_URL}/${formData.image1}`} alt="Image 1" className="w-40 h-40 object-cover" />

                  )}
                </div>
      
                {/* Image 2 Upload */}
                <div>
                  <label className="block text-sm">Image 2 Upload</label>
                  <input
                    type="file"
                    name="image2"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.image2 && (
                                                                                 <img src={`${API_BASE_URL}/${formData.image2}`} alt="Image 2" className="w-40 h-40 object-cover" />

                  )}
                </div>
      
                {/* ID Proof Upload */}
                <div>
                  <label className="block text-sm">ID Proof</label>
                  <input
                    type="file"
                    name="idProof"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.idProof && (
                    <img
                //   src={`http://localhost:3036/uploads/${formData.idProof}`}
                src={formData.idProof}

                      alt=""
                      className="mt-2 h-20 w-20 rounded border"
                    />
                  )}
                </div>
                {/* Address Proof Upload */}
                <div>
                  <label className="block text-sm">Address Proof</label>
                  <input
                    type="file"
                    name="addressProof"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.addressProof && (
                    <img
                    // src={`http://localhost:3036/uploads/${formData.addressProof}`}
                    src={formData.addressProof}

                      alt=""
                      className="mt-2 h-20 w-20 rounded border"
                    />
                  )}
                </div>
      
                {/* Other Proof Upload */}
                <div>
                  <label className="block text-sm">Other Proof</label>
                  <input
                    type="file"
                    name="otherProof"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.otherProof && (
                    <img
                    // src={`http://localhost:3036/uploads/${formData.otherProof}`}
                    src={formData.otherProof}

                      alt="Other Proof"
                      className="mt-2 h-20 w-20 rounded border"
                    />
                  )}
                </div>
      
                {/* Submit Button */}
                <div className="mt-6 flex justify-end">
                  <button
                    type="submit"
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                  >
                    Save
                  </button>
                </div>
              </form>
      
      {alert.message && (
        <div
          className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg z-50 ${
            alert.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          <span>{alert.message}</span>
        </div>
      )}

    </div>
    
  );
};

export default RegisterUser;